import React, { Component } from 'react';
import { connect } from 'react-redux';
import WidgetPreviewModal from '../../../../views/widget/common/modal/WidgetPreviewModal';
import withModal from '../../../../lib/hoc/withModal';
import { widgetActions } from '../../../../store/modules/widget';

class WidgetPreviewModalContainer extends Component {
  constructor(props) {
    super(props);

    this.state = {
      /**
       *  페이지 타입
       *  0 : 홈
       *  1: 윚셋 상세
       */
      pageType: 0,
    };
  }

  /**
   * 페이지 변경
   */
  changePageType = (pageType) => {
    this.setState({
      pageType,
    });
  };

  /**
   * 모달 닫기
   */
  closeModal = () => {
    this.props.toggleModal({ name: 'widgetPreviewModal', value: false });
  };

  render() {
    return (
      <WidgetPreviewModal
        {...this.state}
        {...this.props}
        changePageType={this.changePageType}
        closeModal={this.closeModal}
      />
    );
  }
}

const mapStateToProps = (state) => {
  return {
    isOpen: state.widget.widgetPreviewModal.isOpen,
    data: state.widget.widgetPreviewModal.data,
  };
};

const mapDispatchToProps = {
  toggleModal: widgetActions.toggleModal,
};

export default connect(mapStateToProps, mapDispatchToProps)(withModal()(WidgetPreviewModalContainer));
